export const getProfileColumns = (status: string) => {
    switch (status) {
        case 'userId':
            return 'User Id';
        case 'email':
            return 'Email'
        case 'stratosRoles':
            return 'DE Roles';
        case 'itaProdPolicy':
            return 'Production Policy';
        case 'itaNonProdPolicy':
            return 'Non-Production Policy';
        case 'environment':
            return 'Environment';
        default:
            return status
    }
}